import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { StatusCode } from "api/protocols";

import Page from "components/page/Page";
import Card from "components/card/Card";
import FormLayout from "components/form/FormLayout";
import Form from "components/form/Form";
import Input from "components/form/input/Input";
import { Select } from "components/select/index";

import { IRegisterGroup } from "../../Admin";

import { useTranslation } from "react-i18next";
import { GetRegisterGroups } from "api/rpc/2024-04/facilityAdmin/facility/register/group";
import { PostCardReader } from "api/rpc/2024-04/facilityAdmin/payment/teeonPayments/reader";

interface IProps {
  uiActions: any;
}

export default function CardReaderNew(props: IProps) {
  const { uiActions } = props;
  const { Option } = Select;

  const history = useHistory();
  const { t } = useTranslation();
  const primaryAction = {
    content: t("Create"),
    action: createCardReader,
  };

  const [readerState, setCardReaderState] = useState({
    label: "",
    registration_code: "",
    register_group_id: undefined,
  });

  async function createCardReader() {
    const res = await PostCardReader(readerState, true);
    if (res.status === StatusCode.OK) {
      uiActions.showSuccess(t("Succesfully added new reader"));
    } else {
      uiActions.showError(t("Error adding reader"));
      return;
    }

    history.push("/admin/settings/card_reader");
  }

  function handleInputChange(event: any) {
    const { id, value } = event.target;

    setCardReaderState(prevState => ({ ...prevState, [id]: value }));
  }

  const [registerGroups, setRegisterGroups] = useState<IRegisterGroup[]>([]);

  const LoadRegisterGroups = async () => {
    const res = await GetRegisterGroups();

    if (res.status === StatusCode.OK) {
      if (res.data) {
        setRegisterGroups(res.data as IRegisterGroup[]);
      }
    } else {
      uiActions.showError(t("Error getting register groups"));
    }
  };

  const onChangeRegisterGroup = (register_group_id: number) => {
    setCardReaderState(prevState => ({ ...prevState, register_group_id: register_group_id }));
  };
  useEffect(() => {
    void LoadRegisterGroups();
  }, []);

  return (
    <Page
      title={t("New Card Reader")}
      narrow
      primaryAction={primaryAction}
      breadcrumbs={[
        {
          prefix: true,
          label: t("Hardware"),
          url: "/admin/settings/card_reader",
        },
      ]}
    >
      <Card>
        <Card.Section>
          <Form>
            <FormLayout>
              <FormLayout.Group>
                <div>{t("On the reader, the user enters the key sequence 0-7-1-3-9 to display a unique registration code.")}</div>
              </FormLayout.Group>
              <FormLayout.Group>
                <Input
                  value={readerState.label ? readerState.label : ""}
                  label={t("Label")}
                  id="label"
                  onChange={handleInputChange}
                  placeholder={t("Label")}
                />
                <Input
                  value={readerState.registration_code ? readerState.registration_code : ""}
                  label={t("Registration Code")}
                  id="registration_code"
                  onChange={handleInputChange}
                  placeholder={t("Registration Code")}
                />
                <Select
                  onChange={onChangeRegisterGroup}
                  label={t("Register Group")}
                >
                  {registerGroups.map(registerGroup => (
                    <Option key={registerGroup.id} value={registerGroup.id}>
                      {registerGroup.title}
                    </Option>
                  ))}
                </Select>
              </FormLayout.Group>
            </FormLayout>
          </Form>
        </Card.Section>
      </Card>
    </Page>
  );
}
